import { render, staticRenderFns } from "./AppVehicleInfo.vue?vue&type=template&id=0c440c48&scoped=true&"
import script from "./AppVehicleInfo.vue?vue&type=script&lang=js&"
export * from "./AppVehicleInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppVehicleInfo.vue?vue&type=style&index=0&id=0c440c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c440c48",
  null
  
)

export default component.exports